import type cardId from "./id";

const cardEn: typeof cardId = {
	card: {
		title: "Card",
		subtitle: "Summary of card list & topup",
		download_template: "Download Template",
		tabs: {
			list: "Card List",
			topup: "Topup",
		},
		list: {
			title: "Card Data",
			empty_state: {
				title: "No card data",
				description: "Please add a new card.",
			},
			columns: {
				date: "Date",
				card_no: "Card No",
				customer_name: "Customer Name / Account",
				phone: "Customer Phone",
				card_name: "Name on Card",
				handphone: "Phone",
				type: "Card Type",
				pin_default: "Default Card PIN",
				status: "Status",
				detail: "Detail",
			},
			status: {
				active: "Active",
				inactive: "Inactive",
				block: "Blocked",
			},
		},
		topup: {
			title: "TopUp Data",
			empty_state: {
				title: "No topup data",
				description: "Please top up a card.",
			},
			columns: {
				date: "Date",
				ref_id: "Ref ID",
				count_card: "Total Cards",
				user: "User",
				amount: "Amount",
				fee: "Admin Fee",
				total: "Total",
				status: "Status",
				fee_status: "Admin Fee Status",
			},
			card_unit: "Cards",
			status: {
				paid: "Paid",
				unpaid: "Unpaid",
			},
			batch_modal: {
				trigger: "Batch Topup",
				title: "Batch Topup",
				source_label: "Cazhbox Fund Source",
				source_placeholder: "Select fund source",
				source_loading: "Loading fund sources...",
				no_data: "No Data",
				dropzone_selected: "File selected: {name}",
				dropzone_empty: "Click or drag a file here",
				dropzone_hint: "Format: .xls, .xlsx (max 5MB)",
				cancel: "Cancel",
				upload: "Upload",
				processing: "Processing...",
				alert_select_file: "Please select a file first!",
				alert_select_source: "Please select a fund source first!",
				alert_success: "Batch topup processed successfully!",
				error_title: "Failed to process batch topup",
				error_description: "Something went wrong, please try again.",
				success_title: "Success",
				validation: {
					file_required: "File is required",
					file_type: "File must be .xls or .xlsx",
					file_size: "File size must not exceed 5MB",
					source_required: "Fund source is required",
				},
			},
		},
		detail: {
			error_title: "Failed to load card data",
			error_description:
				"Something went wrong while loading the card detail. Please try again.",
			retry: "Try Again",
			change_pin: "Change PIN",
			card_no: "Card No",
			identify_id: "Identify ID",
			card_type: "Card Type",
			card_version: "Card Version",
			pin_activation: "Activation Card PIN",
			last_change_pin: "Last PIN Change",
			campaign: "Campaign",
			wallets: "Wallets",
			user: "User",
			customer: "Customer",
			status: "Status",
			name: "Name",
			email: "Email",
			phone_number: "Phone Number",
			copy_success_title: "Success",
			copy_card_no_success: "Card No copied to clipboard!",
			copy_identify_id_success: "Identify ID copied to clipboard!",
			change_pin_modal: {
				title: "Change PIN",
				description: "Enter new PIN",
				new_pin_label: "New PIN",
				cancel: "Cancel",
				submit: "Change PIN",
				success_title: "PIN Changed",
				success_description: "PIN has been changed!",
				error_title: "Failed",
				validation_length: "PIN must be 6 characters",
				validation_number: "PIN must be a Number",
			},
			actions: {
				error_title: "Something went wrong!",
				error_description: "please try again in a moment",
				cancel: "Cancel",
				ok: "OK",
				block: {
					trigger: "Block this card",
					title: "Block Card",
					description: "Block this card",
					confirm_message: "Are you sure you want to block this card?",
					confirm: "Block anyway",
					success_title: "Card Blocked",
					success_description: "Card blocked successfully!",
				},
				unblock: {
					trigger: "Unblock this card",
					title: "Unblock Card",
					description: "Unblock this card",
					confirm_message: "Are you sure you want to unblock this card?",
					confirm: "Unblock card",
					success_title: "Card Unblocked",
					success_description: "Card unblocked successfully!",
				},
				activate: {
					trigger: "Activate this card",
					title: "Activate Card",
					description: "Activate this card",
					submit: "Activate",
					success_title: "Card Activated",
					success_description: "Card activated successfully!",
					name_label: "Name",
					name_placeholder: "Enter card user name",
					phone_label: "Phone Number",
					phone_placeholder: "Enter card user phone number",
					pin_label: "PIN",
					validation: {
						name_required: "Name is required",
						name_min: "Name must be at least 3 characters",
						phone_required: "Phone number is required",
						phone_min: "Phone number must be at least 3 characters",
						phone_number: "Phone number must be numeric",
						phone_invalid_format:
							"Invalid Indonesian phone number format (e.g. 08xx, 62xx, +62xx)",
						pin_length: "PIN must be 6 digits",
						pin_number: "PIN must be numeric",
					},
				},
			},
		},
		transaction: {
			title: "Transaction History",
			empty_state: {
				title: "No transaction data",
				description: "No transactions recorded for this card yet.",
			},
			columns: {
				date: "Date",
				ref_id: "Ref ID",
				location: "Location",
				type: "Type",
				wallet: "Wallet",
				nominal: "Amount",
				status: "Status",
			},
			status: {
				success: "Success",
				failed: "Failed",
			},
		},
		actions: {
			warning_title: "⚠️ Warning!",
			cancel: "Cancel",
			ok: "OK",
			toasts: {
				failed_title: "Failed!",
				success_title: "Success",
				error_title: "An error occurred!",
				error_description: "try again in a few moments",
				select_reset_pin:
					"Please check at least one card you want to reset the PIN for!",
				success_reset_pin: "Bulk PIN reset successful!",
				select_reset_user:
					"Please check at least one card you want to reset the user for!",
				success_reset_user: "Bulk user reset successful!",
				select_block: "Please check at least one card you want to block!",
				success_block: "Bulk block successful!",
				select_unblock:
					"Please check at least one card you want to unblock!",
				success_unblock: "Bulk unblock successful!",
			},
			reset_pin: {
				label: "Reset Card PIN",
				message: "Are you sure you want to reset the selected card PIN?",
			},
			reset_user: {
				label: "Reset Card User",
				message: "Are you sure you want to reset the selected card user?",
			},
			block: {
				label: "Block Card",
				message: "Are you sure you want to block the selected card?",
			},
			unblock: {
				label: "Unblock Card",
				message: "Are you sure you want to unblock the selected card?",
			},
		},
	},
};

export default cardEn;
